import { JobsiteDto } from 'app/shared/remote-services/dtos/jobsite.dto'
import { SyncActionFactory } from 'app/shared/utils/redux/sync.actions'
import { CompanyDto } from '../../../core/models/company.dto'
import { ListActionFactory } from '../../../shared/utils/redux/list/list.actions'
import {
  DisplayedFavoriteKPIDto,
  DisplayedFavoriteKpiPayload,
} from '../../jobsite-summary/jobsite-kpi/models/jobsite-favorite-kpi.dto'
import { OrderValues } from '../models/jobsites-filter.model'
import { JobsitesListState } from './state'
import { JobsitePinpointDto } from '../../../shared/remote-services/dtos/jobsitePinpoint.dto'
import { AsyncActionFactory } from '../../../shared/utils/redux/async.actions'
import { FavoriteTechniqueDto } from '../../../shared/remote-services/dtos/technique.dto'
import { FromExcel } from '../models/jobsite-excel-import.model'
import { LoadableActionFactory } from '../../../shared/utils/redux/loadable/loadable.actions'
import { WeeklyReportConfig } from '../models/weekly-report-config.model'
import { LoadableMapActionsFactory } from '../../../shared/utils/redux/loadable-map/loadable-map.actions'
import { JobsiteStatsDto } from '../../../shared/remote-services/dtos/jobsiteStats.dto'
import { UUID } from '../../../shared/models/utils.type'

export class JobsitesListActions {
  public static readonly enterJobsitesList = new SyncActionFactory<void>(
    '[JOBSITES LIST] ENTER',
  )

  public static readonly loadJobsitesList = new SyncActionFactory<void>(
    '[JOBSITES LIST] LOAD',
  )

  public static readonly updateMapSettings = new SyncActionFactory<{
    center: [number, number]
    zoom: number
  }>('[JOBSITES LIST] UPDATE MAP SETTINGS')

  public static readonly initSearchFilters = new SyncActionFactory<void>(
    '[JOBSITES LIST] INIT SEARCH FILTERS',
  )

  public static readonly provideSearch = new SyncActionFactory<string>(
    '[JOBSITES LIST] PROVIDE SEARCH',
  )

  public static readonly clickOnStatus = new SyncActionFactory<
    JobsitesListState['status']
  >('[JOBSITES LIST] CLICK ON STATUS')

  public static readonly setProcessFilter = new SyncActionFactory<
    JobsitesListState['process']
  >('[JOBSITES LIST] SET PROCESS FILTER')

  public static readonly setOrderDirection = new SyncActionFactory<
    JobsitesListState['orderDirection']
  >('[JOBSITES LIST] SET ORDER DIRECTION')

  public static readonly setOrderValue = new SyncActionFactory<OrderValues>(
    '[JOBSITES LIST] SET ORDER VALUE',
  )

  public static readonly setPageSize = new SyncActionFactory<number>(
    '[JOBSITES LIST] SET PAGE SIZE',
  )

  public static readonly setCurrentPage = new SyncActionFactory<number>(
    '[JOBSITES LIST] SET CURRENT PAGE',
  )

  public static readonly setTotalItems = new SyncActionFactory<number>(
    '[JOBSITES LIST] SET TOTAL ITEMS',
  )

  public static readonly displayedJobsites = new ListActionFactory<
    JobsiteDto,
    void
  >('[JOBSITES LIST] DISPLAYED JOBSITES')

  public static readonly setOnlyStarred = new SyncActionFactory<boolean>(
    '[JOBSITES LIST] SET ONLY STARRED',
  )

  public static readonly loadNbAssignedMachines = new SyncActionFactory<{
    [id: UUID]: number
  }>('[JOBSITES LIST] LOAD ASSIGNED MACHINES')

  public static readonly setCompanyValue = new SyncActionFactory<CompanyDto>(
    '[JOBSITES LIST] SET SELECTED COMPANY',
  )

  public static readonly displayedFavoriteKpi = new ListActionFactory<
    DisplayedFavoriteKPIDto,
    DisplayedFavoriteKpiPayload
  >('[JOBSITES LIST] DISPLAYED_FAVORITE_KPI')

  public static readonly setDisplayMode = new SyncActionFactory<
    JobsitesListState['displayMode']
  >('[JOBSITES LIST] SET DISPLAY MODE')

  public static readonly setMapAnimationDone = new SyncActionFactory<boolean>(
    '[JOBSITES LIST] SET MAP ANIMATION DONE',
  )

  public static readonly setListAnimationDone = new SyncActionFactory<boolean>(
    '[JOBSITES LIST] SET LIST ANIMATION DONE',
  )

  public static readonly setRefreshMapSize = new SyncActionFactory<boolean>(
    '[JOBSITES LIST] SET REFRESH MAP SIZE',
  )

  public static readonly loadMapViewPinpoints = new SyncActionFactory<void>(
    '[JOBSITES LIST] LOAD MAP VIEW PINPOINTS',
  )

  public static readonly jobsitesPinpoints = new ListActionFactory<
    JobsitePinpointDto,
    void
  >('[JOBSITES LIST] JOBSITES PINPOINTS')

  public static readonly setFavoriteJobsiteTechnique = new AsyncActionFactory<
    FavoriteTechniqueDto,
    void
  >('[JOBSITES LIST] SET FAVORITE JOBSITE TECHNIQUE')

  public static readonly exportKpiCsv = new SyncActionFactory<void>(
    '[JOBSITES LIST] EXPORT KPI CSV',
  )

  public static readonly importJobsiteFromExcel = new AsyncActionFactory<
    File,
    FromExcel
  >('[JOBSITES LIST] IMPORT JOBSITE FROM EXCEL')

  public static readonly openWeeklyReportConfig = new SyncActionFactory<void>(
    '[JOBSITES LIST] OPEN WEEKLY REPORT CONFIG',
  )

  public static readonly loadWeeklyReportConfig = new LoadableActionFactory<
    void,
    WeeklyReportConfig
  >('[JOBSITES LIST] LOAD WEEKLY REPORT CONFIG')

  public static readonly saveWeeklyReportConfig =
    new SyncActionFactory<WeeklyReportConfig>(
      '[JOBSITES LIST] SAVE WEEKLY REPORT CONFIG',
    )

  public static readonly deleteWeeklyReportConfig = new SyncActionFactory<UUID>(
    '[JOBSITES LIST] DELETE WEEKLY REPORT CONFIG',
  )

  public static readonly loadJobsiteStats =
    new LoadableMapActionsFactory<JobsiteStatsDto>(
      '[JOBSITES LIST] LOAD JOBSITE MAP',
    )

  public static readonly resetJobsitesListPage = new SyncActionFactory<void>(
    '[JOBSITES LIST] RESET JOBSITES LIST PAGE',
  )
}
